import Paper from '@mui/material/Paper'
import {
    Box,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material'
import {AttachFile, ContentCut, TextSnippet, Undo} from '@mui/icons-material'
import {
    updateComparsionChartData,
    updateDisqualificationReasonDialogData,
} from '../../../../store/slice/bidComparsionChart'
import {useDispatch, useSelector} from 'react-redux'
import {usePostDisqualifyMutation} from '../../../../store/api/bidComparsion'
import TextHelper from '../../../../helpers/textHelper'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import React from 'react'
import {toggleUploadDialogInner, toggleUploadDialogMain} from '../../../../store/slice/dialogSlice'

const BidItemLeftTable = ({item, rfqDetails, setBidMainId}) => {
    const isForUAE = JSON.parse(process.env.REACT_APP_FOR_UAE)
    const bidDetails = item?.bidDetails
    const tableCellStyle = {
        borderRight: '1px solid rgba(224, 224,224,1)',
    }
    const chartData = useSelector((state) => state.bidComparsionSlice.comparsionChartData)
    const [postDisqualify] = usePostDisqualifyMutation()
    const selectedBidComparsionGridData = useSelector((state) => state.bidComparsionSlice.selectedGridData)

//   const [bidMainId, setBidMainId] = useState([])
//   const [attachments, setAttachments] = useState([])
//   const [commercialAttachments, setCommercialAttachments] = useState([])

    const dispatch = useDispatch()

    const openDialog = () => {
        dispatch(updateDisqualificationReasonDialogData(item))
    }


//   const { data: attachmentsData } = useGetBIDsAttachmentsQuery(bidMainId)
//   const { data: attachmentsCommercialData, refetch: refetchAttachmentsCommercial } =
//     useGetCommercialAttachmentsQuery(bidMainId)

    const undoElement = () => {
        const index = chartData?.bids?.findIndex((d) => d?.bidMainId == item?.bidMainId)
        let newChartData = {...chartData}
        let newBids = [...chartData?.bids]
        let bidItem = {...newBids[index]}
        bidItem.discualified = 0
        bidItem.discualificationReason = ''
        postDisqualify({
            bidMainId: bidItem?.bidMainId,
            discualified: bidItem?.discualified ? 1 : 0,
            discualificationReason: bidItem?.discualificationReason,
        })
        newBids[index] = bidItem
        newChartData.bids = newBids
        dispatch(updateComparsionChartData(newChartData))
    }
    const isDraft = selectedBidComparsionGridData?.[0]?.status == 0

    return (
        <TableContainer style={{borderRadius: 0, borderRight: `1px solid ${item?.bidApprovals?.length == 0 && '#000'}`}}
                        component={Paper} className="dynamic-table">
            <Table size="small">
                <TableHead>
                    <TableRow className="bg-grey" style={{height: '55px'}}>
                        <TableCell style={{padding: 0}} colspan={isForUAE ? 7 : 6}>
                            <Box display="flex" flexDirection="column" style={{padding: '7px'}}>
                                <Box display="flex" alignItems="center" gap={1}>
                                    <Typography sx={{fontSize: '12px'}}>{item?.bidNo}</Typography>
                                    <IconButton
                                        onClick={() => {
                                            setBidMainId(item?.bidMainId)
                                            dispatch(toggleUploadDialogMain())
                                        }}
                                        sx={{p: 0}}
                                    >
                                        <AttachFile style={{color: '#65c759', marginRight: 3}}/>
                                    </IconButton>
                                    <IconButton
                                        onClick={() => {
                                            setBidMainId(item?.bidMainId)
                                            dispatch(toggleUploadDialogInner())
                                        }}
                                        sx={{p: 0}}
                                    >
                                        <CloudUploadIcon style={{color: '#1565c0', marginRight: 3}}/>
                                    </IconButton>
                                    {isDraft && (
                                        <>
                                            {!Boolean(item?.discualified) && (
                                                <IconButton onClick={openDialog} sx={{p: 0}}>
                                                    <ContentCut style={{color: 'red', marginRight: 3}}/>
                                                </IconButton>
                                            )}
                                            {Boolean(item?.discualified) && (
                                                <IconButton onClick={undoElement} sx={{p: 0}}>
                                                    <Undo style={{color: '#00bce4', marginRight: 3}}/>
                                                </IconButton>
                                            )}
                                            {Boolean(item?.discualified) && (
                                                <IconButton onClick={openDialog} sx={{p: 0}}>
                                                    <TextSnippet style={{color: 'red', marginRight: 3}}/>
                                                </IconButton>
                                            )}
                                        </>
                                    )}
                                </Box>
                                <Typography sx={{fontWeight: 'bold', fontSize: '14px'}}>{item?.vendorName}</Typography>
                            </Box>
                        </TableCell>
                    </TableRow>
                    <TableRow className="bg-grey">
                        <TableCell style={tableCellStyle}>
                            <Typography sx={{fontWeight: 'bold'}}>Quantity</Typography>
                        </TableCell>
                        <TableCell style={tableCellStyle}>
                            <Typography sx={{fontWeight: 'bold'}}>
                                Unit <br/> Price
                            </Typography>
                        </TableCell>
                        <TableCell style={tableCellStyle}>
                            <Typography sx={{fontWeight: 'bold'}}>
                                Total <br/> Amount
                            </Typography>
                        </TableCell>
                        <TableCell style={tableCellStyle}>
                            <Typography sx={{fontWeight: 'bold'}}>
                                Discounted <br/> Amount
                            </Typography>
                        </TableCell>
                        {!isForUAE && (
                            <TableCell style={tableCellStyle}>
                                <Typography sx={{fontWeight: 'bold'}}>
                                    Alternative <br/> Name/Description
                                </Typography>
                            </TableCell>
                        )}
                        {isForUAE && (
                            <>
                                <TableCell style={tableCellStyle}>
                                    <Typography sx={{fontWeight: 'bold'}}>
                                        Margins
                                    </Typography>
                                </TableCell>
                                <TableCell style={tableCellStyle}>
                                    <Typography sx={{fontWeight: 'bold'}}>
                                        Converted Gross
                                    </Typography>
                                </TableCell>
                                <TableCell style={tableCellStyle}>
                                    <Typography sx={{fontWeight: 'bold'}}>
                                        Total With Rate
                                    </Typography>
                                </TableCell>
                            </>
                        )}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rfqDetails?.map((details, index) => (
                        <TableRow
                            style={{height: '35px'}}
                            hover
                            className={`${item?.discualified && 'bg-grey'}`}
                            role="checkbox"
                            tabIndex={-1}
                            key={index}
                        >
                            <TableCell style={tableCellStyle}>{bidDetails?.[index]?.quantity}</TableCell>
                            <TableCell style={tableCellStyle}>{bidDetails?.[index]?.unitPrice}</TableCell>
                            <TableCell style={tableCellStyle}>{bidDetails?.[index]?.totalAmount}</TableCell>
                            <TableCell style={tableCellStyle}>{bidDetails?.[index]?.discountValue}</TableCell>
                            {!isForUAE && (
                                <TableCell style={tableCellStyle}>
                                    {TextHelper.checkTextLength(bidDetails?.[index]?.alternativeDescription, 20)}
                                </TableCell>
                            )}
                            {isForUAE && (
                                <>
                                    <TableCell style={tableCellStyle}>{bidDetails?.[index]?.margins}</TableCell>
                                    <TableCell style={tableCellStyle}>{bidDetails?.[index]?.convertedGross}</TableCell>
                                    <TableCell
                                        style={tableCellStyle}>{bidDetails?.[index]?.baseTotalWithRate}</TableCell>
                                </>
                            )}
                        </TableRow>
                    ))}
                    <TableRow className="bg-grey">
                        {Array.from({length: isForUAE ? 7 : 5}).map((_, index) => (
                            <TableCell style={tableCellStyle} key={index}/>
                        ))}
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default BidItemLeftTable
